import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import SingleUserRow from './SingleUserRow';
import { useEffect, useState } from 'react';
import { UserData, UserProfileData } from 'interfaces/UserData.interface';
import SearchBar from './SearchBar';
import Loader from 'components/atoms/loader';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#312F41',
  boxShadow: 24,
  p: 3,
  borderRadius: '30px',
};

interface IFollowModalProps {
  children: JSX.Element;
  type: 'followers' | 'following';
  data?: UserProfileData;
  isOtherUser: boolean;
  updateComponent: () => void;
}

const FollowUserModal: React.FC<IFollowModalProps> = ({
  children,
  type,
  data,
  isOtherUser,
  updateComponent,
}) => {
  const [open, setOpen] = useState(false);
  const [allUsers, setAllUsers] = useState<UserData[]>([]);
  const [queriedUsers, setQueriedUsers] = useState<UserData[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const authState = useAppSelector(selectAuth);
  const user0 = require('assets/Profile/buku_default_avatar.png');

  useEffect(() => {
    setLoading(true);
    const getUsers = () => {
      if (type === 'followers') {
        setAllUsers([]);
        if (isOtherUser && data) {
          setAllUsers(data.followers.map(follower => follower.follower));
        } else if (authState.followers && !isOtherUser) {
          setAllUsers(authState.followers.map(follower => follower.follower));
        }
      } else {
        setAllUsers([]);
        if (isOtherUser && data) {
          setAllUsers(data.following.map(following => following.following));
        } else if (authState.following && !isOtherUser) {
          setAllUsers(
            authState.following.map(following => following.following)
          );
        }
      }
      setLoading(false);
    };
    getUsers();
  }, [
    type,
    authState.id,
    authState.following,
    authState.followers,
    data,
    isOtherUser,
  ]);

  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: { lg: '500px', xs: '300px' } }}>
          {loading ? (
            <Loader />
          ) : (
            <>
              {' '}
              <SearchBar setQueriedUsers={setQueriedUsers} users={allUsers} />
              {queriedUsers &&
                queriedUsers
                  .filter(user => !!user)
                  .map(user => {
                    return (
                      <SingleUserRow
                        data={user}
                        key={user.id}
                        userId={user.id}
                        username={user.username}
                        avatarSrc={user.avatar || user0}
                        followed={
                          authState.following
                            ? authState.following.some(
                                following =>
                                  following.following.id === user.id &&
                                  !following.unfollowed
                              )
                            : false
                        }
                      />
                    );
                  })}
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default FollowUserModal;
